import { MediaSourceTypeEnum, EventTypeEnum, BroadcastType5ccEnum } from '@goldcast/api/content';
import { AlignedRecordings } from './clip-types';
import { SpeakerWithDetails } from './speaker-types';
import { Word } from './transcript-types';
import { ProcessedSpeakerAnalysis } from './speakers-analysis';

export enum VideoFeedType {
  USER_FEED = 'USER_FEED',
  SCREENSHARE = 'SCREENSHARE',
  SHARED_VIDEO = 'SHARED_VIDEO',
  ORIGINAL = 'ORIGINAL'
}

export interface TimeSpan {
  start: number;
  end: number;
}

export interface CropInfo {
  top_left: { x: number; y: number };
  bottom_right: { x: number; y: number };
}

export interface CropInfoAtTime {
  start: number;
  end: number;
  cropInfo: CropInfo;
}

export interface VideoSource {
  preview: string;
  src: string;
  altText: string;
}
export interface VideoFeed {
  id: string;
  type: VideoFeedType;
  // Can be empty string for screenshares in uploads
  speakerKey: string;
  stageTimeSpans: TimeSpan[];
  speakerSlot: TimeSpan[];
  source: VideoSource;
  cropInfoOverTime: CropInfoAtTime[];
  // Can we empty en case of Originals feed for uploads
  speakerDetails?: SpeakerWithDetails;
  aspectRatio?: number;
}
export interface ContentMetadataStoreLoadingState {
  videoFeedsLoading: boolean;
  speakerAnalysisLoading: boolean;

  // This is required since transcript fetching is not handled in ClipContextProvider. Though it should be moved within ClipContextProvider in the future, and needs to handle pages where transcript is not required.
  transcriptLoading: boolean;
  clipDataLoaded: boolean;
}
export interface ContentMetadataStoreEntity {
  videoFeeds: VideoFeed[];

  // Not meant to be updated directly now. Should be updated when other store gets updated.
  // Once other store are deprecated we should start updating it directly
  metadata: {
    transcript?: Word[];
    speakerAnalysis?: ProcessedSpeakerAnalysis;
    speakerDetails?: Record<string, SpeakerWithDetails>;
    alignedRecordings?: AlignedRecordings[];

    // Derived from clipData. This is required since some of the session details are not directly
    // available in the other store. But we are not using clipData directly since whole clip data is not
    // same for composite segments(splits).
    sessionDetails?: {
      isIndividualRecordingComplete: boolean;
      contentMediaSource: MediaSourceTypeEnum;
      eventType: EventTypeEnum | null;
      broadcastType: BroadcastType5ccEnum;
      originalVideoSource: {
        preview: string;
        source: string;
      };
      // TODO - we will remove this once speaker analysis is enabled on full recording.
      startTime?: number;
      endTime?: number;
      maxVideoDuration?: number;
      usePureCloudRecording?: boolean;
    };
  };
  loading: ContentMetadataStoreLoadingState;
}
export interface ContentMetadataStore {
  [contentId: string]: ContentMetadataStoreEntity;
}
